import './AnimatedLogo.css';

const QUARTERS = ['top-left', 'top-right', 'bottom-left', 'bottom-right'] as const;
const DELAYS = ['', 'logo-delay-1', 'logo-delay-2', 'logo-delay-3'] as const;

interface AnimatedLogoProps {
  /** Rendered box size in px (the logo itself fills ~half of this). Default 120. */
  size?: number;
  className?: string;
}

/**
 * FRAW animated logo ported from the marketing Website navbar.
 * Pure CSS animation — four quarter-circles fold across staggered layers.
 */
export default function AnimatedLogo({ size = 120, className = '' }: AnimatedLogoProps) {
  return (
    <div
      className={`fraw-logo ${className}`.trim()}
      style={{ ['--fraw-logo-size' as string]: `${size}px` }}
      aria-label="FRAW"
      role="img"
    >
      <div className="logo-center-wrapper logo-hue">
        {DELAYS.map((delay) => (
          <div className="logo-circle-container" key={delay || 'base'}>
            {([1, 2] as const).map((layer) =>
              QUARTERS.map((corner) => (
                <div
                  key={`${layer}-${corner}`}
                  className={`logo-quarter layer-${layer} ${corner} ${delay}`.trim()}
                />
              )),
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
